import { HandballEventStatusId } from '@collector/sportsapi-client-legacy'

export const HandballManualAddStatusIds = [
  HandballEventStatusId.FirstHalf,
  HandballEventStatusId.SecondHalf,
  HandballEventStatusId.ExtratimeFirstHalf,
  HandballEventStatusId.ExtratimeSecondHalf,
  HandballEventStatusId.SecondExtratimeFirstHalf,
  HandballEventStatusId.SecondExtratimeSecondHalf,
]
